import { initializeApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyDjJDlcyVX3ai9V8Bvi_8eTxepM5reh_9g",
  authDomain: "vi-viet-nam-bailiff.firebaseapp.com",
  projectId: "vi-viet-nam-bailiff",
  storageBucket: "vi-viet-nam-bailiff.firebasestorage.app",
  messagingSenderId: "694958387585",
  appId: "1:694958387585:web:646e6e1d228c3559bb7880",
  measurementId: "G-0HB5JQ04D4",
};
// recapcha
export const appMain = initializeApp(firebaseConfig);
export const reCAPTCHA = "6LeHXBMrAAAAACayZj1Qzs1cV3wiMsXfXSJkDbXi";
export const MEDIA_STORAGE =
  "https://storage.googleapis.com/" + firebaseConfig.storageBucket + "/";
